import ImageWrapper from "@components/ui-components/image-wrapper";
import { NavLink } from "reactstrap";
import themeConfig from "@configs/theme-config";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import PlatformListDropdown from "./product-list-dropdown/product-list-dropdown";
import { isSuperAdminUrl } from "@src/utility/helpers/utils";

const MenuHeader = props => {
    const { menuCollapsed, setGroupOpen, menuHover } = props;

    const location = useLocation();

    useEffect(() => {
        if (!menuHover && menuCollapsed) setGroupOpen([]);
    }, [menuHover, menuCollapsed]);

    const isAccountRoute = location.pathname.startsWith("/account");
    const showLogo = isAccountRoute || isSuperAdminUrl();

    return (
        <>
            {showLogo ? (
                <NavLink to="/" className="d-flex justify-content-center mb-2">
                    <ImageWrapper
                        src={themeConfig.app.darkLogo}
                        alt="logo"
                        className="mt-1"
                        width={126}/>
                </NavLink>
            ) : (
                <PlatformListDropdown />
            )}
        </>
    );
};

export default MenuHeader;

